import styled from 'styled-components';

export const Rating = styled.span`
  height: 20px;
  margin-top: -15px;
  margin-bottom: 25px;
`;
